module.exports = __webpack_public_path__ + "img/AIS.fa69a735.jpg";